import axios from 'axios/index'
import realJsonp from 'jsonp'
import Qs from 'qs'

// 请求超时时间
axios.defaults.timeout = 100000

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status >= 200 && response.status < 300) {
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },

  (error: any) => {
    // 如果有 response
    if (error.response) {
      const response = error.response
      const errorStr = JSON.stringify(response)
      console.error(errorStr)

      // 401 是 token 失效，转到登录页
      if (response.status === 401) {
        const data = {
          message: '登录失效，请重新登录',
          code: -1,
          error: 1
        }
        return Promise.reject(data)
      }

      if (response.status === 403) {
        const data = {
          message: '操作无权限，请联系管理员',
          code: -1,
          error: 1
        }
        return Promise.reject(data)
      }

      let data: any
      // 如果有 response.data.code 说明是业务代码返回的结果，直接使用
      if (
        error.response.data &&
        typeof error.response.data.code !== 'undefined'
      ) {
        data = error.response.data
      } else if (error.response.data) {
        // 如果没有 response.data.code， 只有 response.data，则将整个 data 作为 message
        data = {}
        data.message = JSON.stringify(error.response.data)
        data.code = -1
        data.error = 1
      }

      // 如果没有获取到 data，则将整个 error 作为 message
      if (!data) {
        data = {}
        data.message = JSON.stringify(error)
        data.code = -1
        data.error = 1
      }

      // 如果 message 太长，只保留前 200 个字符，其它的打在控制台
      if (data.message && data.message.length > 200) {
        console.error(data.message)
        data.message = data.message.substring(0, 200)
      }

      return Promise.reject(data)
    } else {
      // 如果没有 response，可能网络错误或超时
      const errorStr = JSON.stringify(error)
      console.error(errorStr)

      const data: any = {}
      if (error.message) {
        data.message = error.message
        !!error.status &&
        (data.message = data.message + ', status:' + error.status)
      } else {
        data.message = errorStr
      }

      if (data.message && data.message.length > 200) {
        console.error(data.message)
        data.message = data.message.substring(0, 200)
      }

      data.code = -1
      data.error = 1

      return Promise.reject(data)
    }
  }
)

export default {
  jsonp (url: string, callback: any) {
    return new Promise(function (resolve, reject) {
      realJsonp(url, { name: callback }, function (err, data) {
        if (!err) {
          resolve(data)
        } else {
          reject(err)
        }
      })
    })
  },

  async get (url: string, params?: object, headers?: object) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params: params,
          headers: {
            userid: localStorage.getItem('userid'),
            token: localStorage.getItem('token'),
            ...headers
          }
        })
        .then((res: any) => {
          if (res.data && res.data.code === -1) {
            if (res.data.message) {
              alert(res.data.message)
            }
          }
          resolve(res.data)
        })
        .catch(err => {
          alert(err.message)
        })
    })
  },

  async post (url: string, obj: any, headers: any) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, obj, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            userid: localStorage.getItem('userid'),
            token: localStorage.getItem('token'),
            ...headers
          }
        })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          alert(err.message)
        })
    })
  },

  async postParams (url: string, params?: object, headers?: object | undefined) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, Qs.stringify(params), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            userid: localStorage.getItem('userid'),
            token: localStorage.getItem('token'),
            ...headers
          }
        })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          alert(err.message)
        })
    })
  },

  async put (url: string, obj: any, headers?: any) {
    return new Promise((resolve, reject) => {
      axios
        .put(url, obj, {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            userid: localStorage.getItem('userid'),
            token: localStorage.getItem('token'),
            ...headers
          }
        })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          alert(err.message)
        })
    })
  },

  async putParams (url: string, params: any, headers?: any) {
    return new Promise((resolve, reject) => {
      axios
        .put(url, Qs.stringify(params), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            userid: localStorage.getItem('userid'),
            token: localStorage.getItem('token'),
            ...headers
          }
        })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          alert(err.message)
        })
    })
  },

  async delParams (url: string, params: any, headers?: any) {
    return new Promise((resolve, reject) => {
      axios
        .delete(url, {
          params: params,
          headers: {
            userid: localStorage.getItem('userid'),
            token: localStorage.getItem('token'),
            ...headers
          }
        })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          alert(err.message)
        })
    })
  }
}
